import { render, staticRenderFns } from "./Airtime.vue?vue&type=template&id=507701f0"
import script from "./Airtime.vue?vue&type=script&lang=js"
export * from "./Airtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports